// components/Breadcrumbs.js
import { Link } from 'react-router-dom';

export default function Breadcrumbs({ items = [] }) {
  if (!items.length) return null;

  return (
    <nav className="mb-3" aria-label="סימני דרך">
      <ol className="flex flex-wrap items-center gap-y-1 list-none p-0 m-0">
        {items.map((it, i) => {
          const isLast = i === items.length - 1;
          const Tag = isLast || !it.to ? 'span' : Link;
          const props = isLast || !it.to ? {} : { to: it.to };

          return (
            <li key={i} className="inline-flex items-center text-[.95rem]">
              {i > 0 && (
                <span className="mx-1 opacity-50 text-secondary-500 dark:text-secondary-400">›</span>
              )}
              <Tag
                {...props}
                className={
                  isLast
                    ? 'font-semibold text-secondary-900 dark:text-white no-underline'
                    : 'text-primary-600 dark:text-primary-400 no-underline hover:underline'
                }
              >
                {it.label}
              </Tag>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
